const EQUIPMENT_DECIMAL_FACTOR = 1000;

export const truncateEquipmentTo3 = (value: unknown): number | undefined => {
  if (value === null || value === undefined || value === '') return undefined;

  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return undefined;

  return Math.trunc(numeric * EQUIPMENT_DECIMAL_FACTOR) / EQUIPMENT_DECIMAL_FACTOR;
};

export const hasEquipmentMoreThan3Decimals = (value: unknown): boolean => {
  if (value === null || value === undefined || value === '') return false;
  const [, decimals = ''] = String(value).split('.');
  return decimals.length > 3;
};

export const formatEquipmentDecimal3 = (value: unknown, fallback = '-'): string => {
  const normalized = truncateEquipmentTo3(value);
  return normalized === undefined ? fallback : normalized.toFixed(3);
};

export const formatEquipmentMoney3 = (value: unknown, fallback = '-'): string => {
  const normalized = truncateEquipmentTo3(value);
  return normalized === undefined ? fallback : `¥${normalized.toFixed(3)}`;
};

export const calculateEquipmentHourlyPrice3 = (shiftPrice: unknown): number | undefined => {
  const normalizedShiftPrice = truncateEquipmentTo3(shiftPrice);
  if (normalizedShiftPrice === undefined) return undefined;

  return truncateEquipmentTo3(normalizedShiftPrice / 8);
};

export const calculateEquipmentTotal3 = (
  usageHours: unknown,
  unitPrice: unknown
): number | undefined => {
  const normalizedUsageHours = truncateEquipmentTo3(usageHours);
  const normalizedUnitPrice = truncateEquipmentTo3(unitPrice);

  if (normalizedUsageHours === undefined || normalizedUnitPrice === undefined) {
    return undefined;
  }

  return truncateEquipmentTo3(normalizedUsageHours * normalizedUnitPrice);
};

export const normalizeEquipmentUsagePrecision = <T extends {
  usageHours?: unknown;
  cost?: unknown;
  totalCost?: unknown;
  appliedPrice?: unknown;
}>(data: T): T => {
  const normalized: any = { ...data };

  if ('usageHours' in normalized) normalized.usageHours = truncateEquipmentTo3(normalized.usageHours);
  if ('appliedPrice' in normalized) normalized.appliedPrice = truncateEquipmentTo3(normalized.appliedPrice);
  if ('cost' in normalized) normalized.cost = truncateEquipmentTo3(normalized.cost);
  if ('totalCost' in normalized) normalized.totalCost = truncateEquipmentTo3(normalized.totalCost);

  return normalized;
};

export const normalizeEquipmentPricePrecision = <T extends {
  price?: unknown;
  shiftPrice?: unknown;
  unitPrice?: unknown;
}>(data: T): T => {
  const normalized: any = { ...data };

  if ('price' in normalized) normalized.price = truncateEquipmentTo3(normalized.price);
  if ('shiftPrice' in normalized) normalized.shiftPrice = truncateEquipmentTo3(normalized.shiftPrice);
  if ('unitPrice' in normalized) normalized.unitPrice = truncateEquipmentTo3(normalized.unitPrice);

  return normalized;
};
